const slPlan = (() => {
  const pageSeniorLohas = (document.getElementById("pageSeniorLohas") != null);
  if (pageSeniorLohas) {


    let sW = window.innerWidth;

    let centeredSlides;
    let slidesPerView;
    let spaceBetween;

    if (sW > 750) {
      centeredSlides = false
      slidesPerView = 1.0
      spaceBetween = 40
    } else {
      centeredSlides = true
      slidesPerView = 1.3
      spaceBetween = 20
    }

    const swiper = new Swiper("#jsSwiperPlan", {
      loop: true,
      centeredSlides: centeredSlides,
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetween,
      speed: 800,
      navigation: {
        nextEl: ".swiper-btn-next",
        prevEl: ".swiper-btn-prev"
      }
    });

    let swiperCopy = document.getElementById("jsSwiperPlanCopy")
    let num = swiperCopy.querySelector('.js-num');
    let ttl = swiperCopy.querySelector('.js-ttl');
    let txt = swiperCopy.querySelector('.js-txt');
    swiper.on('slideChange', function () {
      if (swiper.realIndex == 0) {
        num.textContent = `#1`;
        ttl.textContent = `リビング`;
        txt.textContent = `南向きのリビングは陽当たりが良く、解放感も抜群。窓の外には緑の森と山が広がり、深呼吸すると心が洗われるよう。この景色は価値であり、静かな朝やのんびりとした休日は、夫婦でこの眺めに癒されている。`;
      } else if (swiper.realIndex == 1) {
        num.textContent = `#2`;
        ttl.textContent = `BRICKS ONE`;
        txt.textContent = `セカンドライフに必要な2人分の荷物や洋服は、マルチクローゼットにひとまとめに。あちこちと探す手間がなくなり、コンパクトですっきりした暮らしが送れるように。シンプルながら機能的なスペースにも満足。`;
      } else if (swiper.realIndex == 2) {
        num.textContent = `#3`;
        ttl.textContent = `洋室2`;
        txt.textContent = `多趣味な夫のために個室を用意。好きなギターをはじめとする楽器や、パソコン、キャンプ用品などが眺められる空間に。楽器の手入れや、持ち帰った仕事など、集中できる場所があるだけで気持ちが落ち着くそう。`;
      } else if (swiper.realIndex == 3) {
        num.textContent = `#4`;
        ttl.textContent = `バルコニー`;
        txt.textContent = `バルコニーでは、妻がプランターで家庭菜園を。ちょっとしたスペースを使って手軽に、美味しい野菜を季節ごとに栽培している。採れたてのハーブやミニトマトが食卓を彩ることが増え、食事がより楽しい時間に。`;
      }
    });

    let swiperBtn = document.getElementById("jsSwiperPlanBtn")
    let btn = swiperBtn.querySelectorAll('.btn');
    for (let i = 0; i < btn.length; i++){
      btn[i].addEventListener('click', () => {
        if(i == 0){
          swiper.slideToLoop(0)
        }
        if(i == 1){
          swiper.slideToLoop(1)
        }
        if(i == 2){
          swiper.slideToLoop(2)
        }
        if(i == 3){
          swiper.slideToLoop(3)
        }
      });
    }


  }
})();
export default slPlan;